/** @format */
import {
  useContext,
  useState,
} from 'react';

import { Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

import { EventContext } from '../../Contexts/EventContext';
import ErrorMessage from '../../Shared/Components/ErrorMessage';
import {
  error,
  success,
} from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { serverErrorHandler } from '../../Shared/utils/helper';

const validationSchema = Yup.object().shape({
  nat_code: Yup.string()
    .required('لطفا کد ملی را وارد نمایید')
    .length(10, 'کد ملی باید دقیقاً ۱۰ کاراکتر باشد'),
  mobile: Yup.string()
    .required('موبایل نمی‌تواند خالی باشد')
    .min(11, 'موبایل نمی‌تواند کمتر از 11 کاراکتر باشد')
    .max(11, 'موبایل نباید بیشتر از 11 کاراکتر باشد'),
});

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const eventContext = useContext(EventContext);
  const [serverErrors, setServerErrors] = useState({});

  const onSubmitLoginForm = async (values, { setSubmitting }) => {
    setSubmitting(true);
    setLoading(true);

    await useApi.post(
      '/auth/forgot/password',
      values,
      (res) => {
        const smsLogOnly = res?.data?.data?.sms_log_only === true;
        success(
          smsLogOnly
            ? 'ارسال پیامک روی سرور غیرفعال است (SMS_DISABLED). کد تأیید در فایل لاگ Laravel در مسیر storage/logs ثبت شده است.'
            : 'کد تایید به موبایل شما ارسال شد',
        );
        navigate('/forgot/password/change', {
          state: {
            mobile: values.mobile,
            nat_code: values.nat_code,
          },
        });
        setSubmitting(false);
        setLoading(false);
        return;
      },
      (err) => {
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors);
          setSubmitting(false);
          setLoading(false);
        } else {
          error('خطای ناخواسته‌ای رخ داده است');
          setSubmitting(false);
          setLoading(false);
        }
      },
    );

    setSubmitting(false);
    setLoading(false);
  };

  return (
    <div className='w-100 d-flex flex-column justify-content-center align-items-center bg-purple vh-100'>
      <section className='container'>
        <Formik
          initialValues={{ nat_code: '', mobile: '' }}
          validationSchema={validationSchema}
          onSubmit={onSubmitLoginForm}
        >
          {({ values, errors, handleChange, handleSubmit, isSubmitting }) => (
            <form onSubmit={handleSubmit}>
              <div className='row'>
                {/* لوگو و توضیحات */}
                <div className='col-12 d-flex flex-column p-2 text-center'>
                  <img
                    className='w-15 mx-auto'
                    src={eventContext?.setting?.logo?.logo ?? ''}
                    alt={eventContext?.setting?.name}
                  />
                  <h3 className='text-dark-mode f-14 my-3'>
                    برای بازیابی کلمه عبور اطلاعات خواسته شده را وارد کنید.{' '}
                  </h3>
                  <div className='d-flex flex-row my-3 align-items-center'>
                    <hr className='w-30 bg-hr' />
                    <span className='text-dark-mode f-14 mx-2'>
                      بازیابی کلمه عبور {eventContext?.setting?.name ?? ''}
                    </span>
                    <hr className='w-30 bg-hr' />
                  </div>
                </div>

                {/* کد ملی */}
                <div className='col-12 col-md-6 offset-md-3'>
                  <div className='form-group d-flex flex-column'>
                    <label className='text-dark-mode f-15 text-left my-2'>
                      کد ملی
                    </label>
                    <input
                      type='text'
                      name='nat_code'
                      value={values.nat_code}
                      onChange={handleChange}
                      className='text-center dir-ltr form-control bg-dark-mode border-0 rounded-1 f-14 text-white'
                    />
                    <ErrorMessage
                      error={
                        errors?.nat_code
                          ? errors?.nat_code
                          : serverErrors?.nat_code
                      }
                      classes='my-2 f-13'
                    />
                  </div>
                </div>

                {/* کد ملی */}
                <div className='col-12 col-md-6 offset-md-3'>
                  <div className='form-group d-flex flex-column'>
                    <label className='text-dark-mode f-15 text-left my-2'>
                      موبایل
                    </label>
                    <input
                      type='text'
                      name='mobile'
                      value={values.mobile}
                      onChange={handleChange}
                      className='text-center dir-ltr form-control bg-dark-mode border-0 rounded-1 f-14 text-white'
                    />
                    <ErrorMessage
                      error={
                        errors?.mobile ? errors?.mobile : serverErrors?.mobile
                      }
                      classes='my-2 f-13'
                    />
                  </div>
                </div>

                {/* دکمه ورود */}
                <div className='col-12 col-md-6 offset-md-3'>
                  <div className='form-group d-flex flex-column'>
                    <button
                      type='submit'
                      className='btn btn-info rounded-1 my-2'
                      disabled={isSubmitting}
                    >
                      {loading ? (
                        <div
                          className='spinner-border spinner-border-sm text-white'
                          role='status'
                        />
                      ) : (
                        'بازیابی کلمه عبور'
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </section>
    </div>
  );
};

export default ForgotPassword;
